
import { defineComponent, ref } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

export default defineComponent({
  name: "sign-in",
  components: {},
  setup() {
    const store = useStore();
    const router = useRouter();

    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      email: Yup.string().required().label("UserName"),
      password: Yup.string().min(4).required().label("Password"),
      toc: Yup.boolean().required(),
    });

    //Form submit function

    const onSubmitLogin = (values) => {
      const elemail: HTMLInputElement | null =
        document.querySelector("#txtUserName");
      const elpassword: HTMLInputElement | null =
        document.querySelector("#txtUserPassword");
      let val = {
        email: elemail?.value,
        password: elpassword?.value,
      };
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      // if (val) {
      //   // Activate indicator
      //  val.setAttribute("data-kt-indicator", "on");
      // }

      // Dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.LOGIN, val)
          //.then(() => {
          //  Swal.fire({
          //    text: "All is cool! Now you submit this form",
          //    icon: "success",
          //    buttonsStyling: false,
          //    confirmButtonText: "Ok, got it!",
          //    customClass: {
          //      confirmButton: "btn fw-bold btn-light-primary",
          //    },
          //  }).then(function () {
          // Go to page after successfully login
          //    router.push({ name: "dashboard" });
          //  });
          //})
          .then(function () {
            router.push({ name: "GasPrices" });
          })
          .catch(() => {
            Swal.fire({
              text: store.getters.getErrors[0],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });

        //Deactivate indicator
        submitButton.value?.removeAttribute("data-kt-indicator");
      }, 2000);
    };

    return {
      onSubmitLogin,
      login,
      submitButton,
    };
  },
});
